import { BrowserRouter, Route, Switch } from "react-router-dom";
import ContactUs from "./routes/ContactPage";
import AboutUs from "./routes/AboutPage";
import Subscription from "./routes/SubscriptionPage";
import FAQPage from "./routes/FAQPage";
import LandingPage from "./routes/LandingPage";
import Testing from "./routes/testing";
import Login from "./routes/LoginPage";
import ScrollToTop from "./components/ScrollManager";
import Signup from "./routes/SignUpPage";
import PrivacyPolicyPage from "./routes/PrivacyPolicy";
import TermsAndConditionsPage from "./routes/TermsAndConditions";
import Success from "./routes/SuccessPage";

function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop>
          <Switch>
            <Route path="/testing" component={Testing} />
            <Route path="/contact" component={ContactUs} />
            <Route path="/login" component={Login} />
            <Route path="/signup" component={Signup} />
            <Route path="/faq" component={FAQPage} />
            <Route path="/subscription" component={Subscription} />
            <Route path="/about" component={AboutUs} />
            <Route path="/privacy-policy" component={PrivacyPolicyPage} />
            <Route path="/success" component={Success} />
            <Route
              path="/terms-and-conditions"
              component={TermsAndConditionsPage}
            />
            <Route path="/" component={LandingPage} />
          </Switch>
        </ScrollToTop>
      </BrowserRouter>
    </div>
  );
}

export default App;
